export const unsafeTypeCast = <TDestination>(source: unknown): TDestination => (source as unknown) as TDestination;
